module.exports = __webpack_public_path__ + "img/Picture7.118889fc.png";